module.exports = __webpack_public_path__ + "static/media/se-logo-white.83a4954f.svg";